// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/tabelname.css
// module id = 393
// module chunks = 3